import './src/styles/global.css';

export const shouldUpdateScroll = ({ routerProps: { location }, getSavedScrollPosition }) => {
  if (location.hash) {
    const el = document.querySelector(location.hash);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
      return false;
    }
  }

  if (location.state?.preserveScroll) {
    return false;
  }

  window.scrollTo(0, 0);
  return false;
};
 
